import React, {useEffect, useState} from "react";
import "../../../../Dashboard/Dashboard.css";
import "../../../../Dashboard/Sidebar.js";
import Header from "../../../../layout/header";
import BottomMenu from "../../../../layout/bottomMenu";
import SuccessModal from "../../../../CustomModal/Success";
import FailedModal from "../../../../CustomModal/Failed";
import DashboardMenu from "../.././../../layout/dashboardMenu";
import Loader from "../../../../../Loader/Loader";
import {toast} from "react-toastify";
import SearchLocation from "../../../../searchLocation/searchLocation";
import useCurrentLocation from "../../../../../hooks/currentlocation/useCurrentlocation";
import FileUpload from "../../../../FileUploads/FileUpload";

const SaveUCDLead = ({
                         history = null,
                         saveLead,
                         lead = [],
                         getLeadById,
                         leadById = [],
                         match,
                         locationPinCode,
                         pincodeData,
                         documentUploadUrlPublic,
                         documentUrlDataPublic,
                         firmType,
                         firmTypesValue = []
                     }) => {
    const islatlng = useCurrentLocation();
    const [inputData, SetInputData] = useState([
        {
            name: "",
            contact: "",
            email: "",
            account_name: "",
            lat: "",
            long: "",
            address: "",
            type: "",
            meta_data: {},
            business_photo:[]
        },
    ]);
    const [isLoading, setIsLoading] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [userMessage, setUserMessage] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [isAllow, setIsAllow] = useState(false);
    const [mapLocation, setMapLocation] = useState({
        address: "Delhi",
        lat: 0,
        lng: 0,
    });
    const [lat, setLat] = useState("");
    const [long, setLong] = useState("");
    const [pincodeValue, setPincodeValue] = useState('')
    const [pincode, setPincode] = useState([]);
    const [otherEntity, setOtherEntity] = useState("");

    useEffect(async () => {
        setIsLoading(true);
        await firmType();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        if (match?.params.id !== undefined) {
            (async () => {
                setIsLoading(true);
                await getLeadById(match?.params.id);
                setIsLoading(false);
            })();
        }
    }, []);

    const [optOption, setOptOption] = useState({
        address2: "",
        currentLocation: "",
    });

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: "Delhi6",
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        if (leadById && leadById?.data !== undefined) {

            let list = [...inputData];
            list[0]["name"] = leadById?.data?.name;
            list[0]["email"] = leadById?.data?.email;
            list[0]["contact"] = leadById?.data?.number;
            list[0]["account_name"] = leadById?.data?.account_name;
            setOptOption({...optOption, currentLocation: leadById?.data?.address});
            list[0]['address'] = leadById?.data?.address
            list[0]["designation"] = leadById?.data?.designation;
            list[0]["other_designation"] = leadById?.data?.other_designation;
            setLong(leadById?.data?.longitude);
            setLat(leadById?.data?.latitude);
            list[0]["lat"] = leadById?.data?.latitude;
            list[0]["long"] = leadById?.data?.longitude;
            SetInputData(list);

        }
    }, [leadById]);

    const handleInputValue = (val, key, metaKey = '', e) => {
        const list = [...inputData];
        if (key === 'meta_data') {
            list[0][key][metaKey] = val
        } else {
            list[0][key] = val;
        }
        SetInputData(list);
    };


    useEffect(() => {
        setIsFailedModalOpen(false);
        setIsSuccessModalOpen(false);
        if (parseInt(lead?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1);
            setIsSuccessModalOpen(true);
            setUserMessage(lead?.message);
        } else if (lead?.status !== undefined && lead?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1);
            setIsFailedModalOpen(true);
            setUserMessage(lead?.message);
        }
    }, [lead]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        let list = [...inputData];
        list[0]["lat"] = lat;
        list[0]["long"] = long;
        if (list[0]["long"] == null || list[0]["lat"] == null) {
            toast.error("Please enable your location");
            return false;
        }
        list[0]["type"] = "UCD";

        if(!list[0]?.address){
            toast.error("Address is missing");
            return false;
        }

        console.log(list)
        console.log(list[0]['business_photo'].length)
        if(list[0]['meta_data']?.business_photo.length === 0){
            toast.error("Please upload business photo");
            return false;
        }
        // console.log('List Data:', list[0]);
        // return false;
        setIsLoading(true);
        await saveLead(list[0]);
        setIsLoading(false);
        setRedirectUrl("ucd-lead-list/");
    };

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            let list = [...inputData];
            list[0]["lat"] = latlng?.lat;
            list[0]["long"] = latlng?.lng;
            SetInputData(list);
            setLong(latlng?.lng);
            setLat(latlng?.lat);
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({...optOption, currentLocation: value});
        handleInputValue(value, "address");
    };

    useEffect(() => {
        (async () => {
            if (pincodeValue === '') {
                return false
            }
            await locationPinCode(pincodeValue)
            handleInputValue(pincodeValue, 'meta_data', 'pincode')
        })();
    }, [pincodeValue])

    useEffect(() => {

        setPincode([])
        if (pincodeData && pincodeData.length > 0) {
            setPincode(pincodeData[0])
            handleInputValue(pincodeData[0]?.geo_city_id, 'meta_data', 'geo_city_id')
            handleInputValue(pincodeData[0]?.city_name, 'meta_data', 'city_name')
            handleInputValue(pincodeData[0]?.geo_state_id, 'meta_data', 'state_id')
            handleInputValue(pincodeData[0]?.state_name, 'meta_data', 'state_name')
        }
    }, [pincodeData])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />

            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={
                                match?.params?.id !== undefined ? "Edit Dealer" : "Add Lead"
                            }
                        />

                        {/*BODY*/}

                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <h1 className="h3 mb-0 text-black-100 hide">Lead</h1>
                            </div>

                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header"></div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                onChange={(e) => {handleInputValue(e.target.value, 'account_name')}}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Business Name
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>

                                                        {/*<div className="col-md-6 float-field ">*/}
                                                        {/*    <input*/}
                                                        {/*        type="text"*/}
                                                        {/*        className="form-control form-control-user"*/}
                                                        {/*        required={true}*/}
                                                        {/*        onChange={(e) => {handleInputValue(e.target.value, 'meta_data', 'channel_name')}}*/}
                                                        {/*    />*/}

                                                        {/*    <label className="large-label float-lb">*/}
                                                        {/*        Channel Name*/}
                                                        {/*        <i className="bi bi-asterisk astrick-icon"></i>*/}
                                                        {/*    </label>*/}
                                                        {/*</div>*/}
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required
                                                                onChange={(e) => {handleInputValue(e.target.value, 'name', '', e)}}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Owner Name
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-md-6 float-field ">
                                                            <select
                                                                className="form-control form-control-user"
                                                                onChange={(e) => {
                                                                    handleInputValue(e.target.value, 'meta_data', 'channel_type', e)
                                                                }}
                                                                required
                                                            >
                                                                <option>Select Dealer Type</option>
                                                                <option value="Dealer">Dealer</option>
                                                                <option value="DSA" >DSA</option>
                                                            </select>
                                                            <label
                                                                className="large-label float-lb">
                                                                Channel Type <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-md-6 float-field ">
                                                            <select
                                                                className="form-control form-control-user"
                                                                onChange={(e) => {
                                                                    console.log(e);
                                                                    handleInputValue(e.target.options[e.target.selectedIndex].text, 'meta_data', 'type_of_entity', e)
                                                                    setOtherEntity(e.target.value);
                                                                }}
                                                                required={true}
                                                            >
                                                                <option>Select Type of Entity</option>
                                                                {/*<option value="Public Ltd">Public Ltd</option>*/}
                                                                {/*<option value="Individual" >Individual</option>*/}
                                                                {/*<option value="Company" >Company</option>*/}
                                                                {/*<option value="HUF" >HUF</option>*/}
                                                                {firmTypesValue.map(val => {
                                                                    return (
                                                                        <>
                                                                            <option
                                                                                value={val?.id}>{val?.firm_name}
                                                                            </option>
                                                                        </>
                                                                    )
                                                                })}

                                                            </select>
                                                            <label
                                                                className="large-label float-lb">
                                                                Type of Entity <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>

                                                        {parseInt(otherEntity) === 5 &&
                                                            <div className="col-md-6 float-field ">
                                                                <input
                                                                    type="number"
                                                                    className="form-control form-control-user"
                                                                    required={true}
                                                                    onChange={(e) => {
                                                                        handleInputValue(e.target.value, 'meta_data', 'type_of_entity', e)
                                                                    }}
                                                                />

                                                                <label className="large-label float-lb">
                                                                    Type of Entity
                                                                    <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                        }
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                    handleInputValue(value, 'contact', '', e);
                                                                    e.target.value = value; // Update the input field with only numeric characters
                                                                }}
                                                                maxlength={10}
                                                                minlength={10}
                                                                pattern="[0-9]*"
                                                                inputMode="numeric"
                                                            />

                                                            <label className="large-label float-lb">
                                                                Phone Number
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="email"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                onChange={(e) => {handleInputValue(e.target.value, 'email', '', e)}}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Email
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <SearchLocation
                                                            handleCurrentLocationBlur={
                                                                handleCurrentLocationBlur
                                                            }
                                                            value={optOption.currentLocation}
                                                            handleCurrentLocationChange={
                                                                handleCurrentLocationChange
                                                            }
                                                            label={"Address"}
                                                            setPincodeValue={setPincodeValue}
                                                        />
                                                        <div className="col-md-6 float-field mt-3">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       setPincodeValue(e.target.value, 'pincode')
                                                                   }}
                                                                   value={pincodeValue}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Pincode <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInputValue(pincode?.geo_city_id, 'meta_data', 'geo_city_id', e)
                                                                   }}
                                                                   disabled
                                                                   value={pincode?.city_name !== undefined ? pincode?.city_name : ''}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInputValue(pincode?.geo_state_id, 'meta_data', 'geo_state_id', e)
                                                                   }}
                                                                   disabled
                                                                   value={pincode?.state_name !== undefined ? pincode?.state_name : ''}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Geographical State <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 float-field  mb-3">
                                                            <FileUpload
                                                                id={`addAttachment`}
                                                                accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                documentUploadUrl={documentUploadUrlPublic}
                                                                documentUrlData={documentUrlDataPublic}
                                                                onChange={(val) => {
                                                                    handleInputValue(val, 'meta_data', 'business_photo')
                                                                }}
                                                                required={true}
                                                                multiple={true}
                                                            >
                                                                Business Photo <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </FileUpload>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-4">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        {match?.params?.id !== undefined ? "Update" : "Submit"}
                                    </button>
                                </div>
                            </form>
                            <img src="../img/leads.gif" width="90%"/>
                        </div>
                    </div>
                </div>

                <BottomMenu/>
            </div>
            {/* section ends */}
        </>
    );
};
export default SaveUCDLead;
